import { createAsyncTypes } from 'utils/ActionCreator'

export const DATA_REQUEST_ASYNC = createAsyncTypes(
  'DATA_REQUEST',
  'ResolutionCenter/ReportedIncidents'
)

export const SEARCH_CHANGE = 'ResolutionCenter/ReportedIncidents/SEARCH_CHANGE'
export const SEARCH_RESET = 'ResolutionCenter/ReportedIncidents/SEARCH_RESET'
export const PAGINATE_CHANGE = 'ResolutionCenter/ReportedIncidents/PAGINATE_CHANGE'
export const GENERAL_FILTER_CHANGE = 'ResolutionCenter/ReportedIncidents/GENERAL_FILTER_CHANGE'
export const DATE_FILTER_CHANGE = 'ResolutionCenter/ReportedIncidents/DATE_FILTER_CHANGE'
export const SET_DETECTED_BY_FILTER = 'ResolutionCenter/ReportedIncidents/SET_DETECTED_BY_FILTER'
export const SORTING_CHANGE = 'ResolutionCenter/ReportedIncidents/SORTING_CHANGE'
